import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export function useVencimientosDetalle() {
  return useQuery({
    queryKey: ['vencimientos-detalle'],
    queryFn: () => cliente.vencimientos.detalle(),
    refetchOnWindowFocus: true,
  });
}
